import NestedForm from "@stimulus-components/rails-nested-form";

export default class extends NestedForm {
  connect() {
    super.connect();
    // Reset any _destroy fields to false on page load
    this.element.querySelectorAll('input[name*="_destroy"][value="1"]').forEach((destroyField) => {
      if (destroyField.closest(this.wrapperSelectorValue).style.display !== "none") {
        destroyField.value = "0";
      }
    });
  }
}
